function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  background-color: ",
        ";\n  color: white;\n  margin: 0;\n  padding: 0;\n  padding: 8px 0;\n  position: absolute;\n  right: ",
        ";\n  top: 0;\n  text-align: center;\n  transform: translateX(30%) translateY(0%) rotate(45deg);\n  transform: ",
        ";\n  transform-origin: top left;\n  width: 96px;\n\n  &:before,\n  &:after {\n    background-color: ",
        ';\n    content: "";\n    height: 100%;\n    margin: 0 -1px; /* Removes tiny gap */\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  &:before {\n    right: 100%;\n  }\n\n  &:after {\n    left: 100%;\n  }\n\n  & > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 96px;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var StyledCardRibbon = styled.div.withConfig({
    componentId: "sc-57513cf-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.zIndices.ribbon;
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? 0 : "auto";
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? "translateX(30%) translateY(0%) rotate(45deg)" : "translateX(0%) translateY(200%) rotate(-45deg)";
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
});
var CardRibbon = function(_param) {
    var variantColor = _param.variantColor, text = _param.text, ribbonPosition = _param.ribbonPosition, props = _objectWithoutProperties(_param, [
        "variantColor",
        "text",
        "ribbonPosition"
    ]);
    return /*#__PURE__*/ _jsx(StyledCardRibbon, _objectSpread({
        variantColor: variantColor,
        ribbonPosition: ribbonPosition
    }, props, {
        children: /*#__PURE__*/ _jsx("div", {
            title: text,
            children: text
        })
    }));
};
CardRibbon.defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    ribbonPosition: "right"
};
export default CardRibbon;
